import { Link } from "@tanstack/react-router";
import { GitCompareArrows, X } from "lucide-react";
import { useCompare, MAX_COMPARE } from "@/lib/compare";

/**
 * Floating bar showing the current compare selection with quick access to the
 * Compare page and a Clear All action. Hidden when nothing is selected.
 */
export function CompareBar({ className = "" }: { className?: string }) {
  const { count, clear } = useCompare();
  if (count === 0) return null;

  return (
    <div
      className={`pointer-events-auto fixed inset-x-0 bottom-0 z-40 px-3 pb-[calc(env(safe-area-inset-bottom)+0.75rem)] sm:px-6 ${className}`}
    >
      <div className="mx-auto grid max-w-3xl grid-cols-[minmax(0,1fr)_auto] items-center gap-3 rounded-2xl border border-border bg-card/95 p-3 shadow-lg backdrop-blur">
        <div className="flex min-w-0 items-center gap-2">
          <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-brand-soft text-brown-dark">
            <GitCompareArrows className="h-4 w-4" />
          </span>
          <div className="min-w-0">
            <p className="truncate text-sm font-bold text-brown-dark">
              {count} of {MAX_COMPARE} selected
            </p>
            <p className="truncate text-[11px] text-muted-foreground">
              Compare images, price, area and more
            </p>
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <button
            type="button"
            onClick={clear}
            className="flex items-center gap-1 rounded-xl border border-border px-3 py-2 text-xs font-semibold text-brown-dark transition hover:bg-secondary"
          >
            <X className="h-3.5 w-3.5" /> Clear All
          </button>
          <Link
            to="/compare"
            className="rounded-xl bg-brand px-3.5 py-2 text-xs font-semibold text-brown-dark shadow-soft transition hover:brightness-105"
          >
            Compare
          </Link>
        </div>
      </div>
    </div>
  );
}
